module.exports = __webpack_public_path__ + "static/media/sort.2d738644.svg";